'use client';

import Link from 'next/link';

export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6 text-center px-4">
      <h1 className="text-[48px] font-semibold text-text-primary">
        Algo salió mal
      </h1>
      <p className="text-text-secondary text-lg">
        Ocurrió un error inesperado. Intentá de nuevo o volvé al inicio.
      </p>
      <div className="flex gap-4">
        <button
          onClick={reset}
          type="button"
          className="border border-border-primary px-6 py-3 rounded-full font-medium hover:bg-surface-secondary transition-colors"
        >
          Reintentar
        </button>
        <Link
          href="/"
          className="bg-gradient-brand text-text-inverse px-6 py-3 rounded-full font-medium hover:opacity-90 transition-opacity"
        >
          Ir al inicio
        </Link>
      </div>
    </div>
  );
}
